import CookieList from '../components/cookie/List.vue';
import CookieCreate from '../components/cookie/Create.vue';
import CookieUpdate from '../components/cookie/Update.vue';
import CookieShow from '../components/cookie/Show.vue';

export default [
  { name: 'CookieList', path: '/cookies/', component: CookieList },
  { name: 'CookieCreate', path: '/cookies/create', component: CookieCreate },
  { name: 'CookieUpdate', path: "/cookies/edit/:id", component: CookieUpdate },
  { name: 'CookieShow', path: "/cookies/show/:id", component: CookieShow  }
];



// WEBPACK FOOTER //
// ./src/routes/cookie.js